export default __webpack_public_path__ + "static/media/kjfeng-incontext-chi22.120e279d.pdf";